<template>
    <div>
    <v-card
        class="mx-auto mt-4"
        max-width="95%"
        elevation="2"
    >
    <v-toolbar
        color="#37474F"
        dark
        class="flex-wrap"
    >

    <v-toolbar-title>현금교환 주문 리스트 </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-spacer></v-spacer>
    <v-btn width="120px"
                color="blue"
                class='white--text'
                @click="checkBoxEnable_all()">선택하기</v-btn>
    <div style="width:10px"></div>


    <v-btn
        v-if="Object.values(enable_check_list).some(Boolean)"
        width="120px"
        color="orange"
        class="white--text"
        @click="update_checked_Done()"
    >완료처리</v-btn>
    <div style="width:10px"></div>
    <v-btn
        v-if="Object.values(enable_check_list).some(Boolean)"
        width="150px"
        color="green"
        class="white--text"
        @click="download_checked_Excel()"
    >엑셀로 내려받기{{ selectedCount > 0 ? ` (${selectedCount})` : '' }}</v-btn>
    </v-toolbar>

    <v-list two-line>
    <v-list-item-group        
        active-class="pink--text"
        multiple
    >
    <div style="overflow-x: auto;">
    <v-data-table
        :footer-props="{'items-per-page-options':[20, 50, -1]}"
        :headers="headers"
        :items="order_list"
        :loading="loadingData"
        >
        <template v-slot:item="row">
            <tr :style="{ backgroundColor: !isAfterThisMonday(row.item.CREATE_DT) ? '' : '#f0f0f0' }">
                <td><span :style="{ fontWeight: '900'}">{{row.item.BANK_NAME}}</span></td>
                <td><span :style="{ fontWeight: '900'}">{{row.item.BANK_ACCOUNT}}</span></td>
                <td><span :style="{ fontWeight: '900'}">{{calc_realcash(row.item.CASH_PID)}}</span></td>
                <td><span :style="{ fontWeight: '900'}">{{row.item.RECIPIENT_NM}}</span></td>
                <td><span :style="{ fontWeight: '900'}">{{convert_phone(row.item.PHONE)}}</span></td>
                <td>{{row.item.CREATE_DT}}</td>
                <td><span :style="{ fontWeight: '900'}">{{row.item.PID}}</span></td>
                <td><span :style="{ fontWeight: '900'}">{{row.item.USER_ID}}</span></td>
                <td>
                <v-checkbox
                    v-model="row.item.selected"
                    :disabled="!isEnableCheckBox(row.item.PID)"
                    :input-value="row.item.selected"
                    @change="row.item.selected = $event"
                    hide-details
                    dense
                    ></v-checkbox>
                </td>
                <td><span :style="{ fontWeight: '900', color: row.item.PROCESS_STATE == 'WAIT' ? 'blue' : 'grey' }">{{row.item.PROCESS_STATE}}</span></td>
                <!-- <td>  <span :style="{ fontWeight: '900', color: row.item.ENABLE == 'Y' ? 'blue' : 'red' }">{{row.item.ENABLE}}</span></td>
                <td>  <span :style="{ fontWeight: '900', color: row.item.DESTINATION_TAG == 'Y' ? 'blue' : 'red' }">{{row.item.DESTINATION_TAG}}</span></td> -->
                <!-- <td v-if="dialog_selected_item.PROCESS_STATE == 'WAIT'"> -->
                <td>
                    <v-btn width="120px"
                    color="indigo"
                    class='white--text'
                    @click="OnClick_ShowPopup_EditCoin(row.item)">상세</v-btn>
                </td>
            </tr>
        </template>
    </v-data-table>
    </div>
        </v-list-item-group>
    </v-list>
    </v-card>
    <v-dialog
      v-model="dialog_popup"
      max-width="680"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
    <v-card>
        <v-card-title class="text-h5 mb-3">
          {{'유저 주문명세[ ' +dialog_selected_item.USER_ID+" / "+dialog_selected_item.USER_NICK + " ]"}}
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="12"  class="dialog_title_text" style="color: blue;"> 주문날짜 : {{dialog_selected_item.CREATE_DT}}</v-col>
            </v-row>

     <v-row>
        <v-col cols="12" sm="5"  class="dialog_title_text">은행</v-col>
        <v-col class="dialog_info_text">
            {{ dialog_selected_item.BANK_NAME }}
        </v-col>
    </v-row>
    <v-divider style="height: 5px;"></v-divider>
    <v-row>
        <v-col cols="12" sm="5"  class="dialog_title_text">계좌번호</v-col>
        <v-col class="dialog_info_text">
            {{ dialog_selected_item.BANK_ACCOUNT }}
        </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row>
        <v-col cols="12" sm="5"  class="dialog_title_text">입금액</v-col>
        <v-col class="dialog_info_text">
            {{ calc_realcash(dialog_selected_item.CASH_PID) }} 원
        </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row>
        <v-col cols="12" sm="5"  class="dialog_title_text">수취자 이름</v-col>
        <v-col class="dialog_info_text">
            {{ dialog_selected_item.RECIPIENT_NM }}
        </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row>
        <v-col cols="12" sm="5"  class="dialog_title_text">전화번호(연락처)</v-col>
        <v-col class="dialog_info_text">
            {{ dialog_selected_item.PHONE }}
        </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row>
        <v-col cols="12" sm="5"  class="dialog_title_text">스냅코인 가격</v-col>
        <v-col class="dialog_info_text">
            {{ dialog_selected_item.SNAP_COIN_PRICE }}
        </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row class="align-center">
    <v-col cols="5" class="d-flex align-center">
        <div class="dialog_title_text" style="margin-top: 10px; margin-bottom: 10px;">처리상태</div>
    </v-col>

    <v-col v-if="dialog_selected_item.PROCESS_STATE == 'WAIT' || dialog_selected_item.PROCESS_STATE == ''" class="d-flex align-center">
        <v-select
        v-model="dropdown_selected"
        :items="dropdown_items"
        label="선택하세요"
        outlined
        dense
        hide-details
        style="width: 100%"
        ></v-select>
    </v-col>
    <v-col v-else class="d-flex align-center">
        <div class="dialog_info_text" style="margin-top: 10px; margin-bottom: 10px;">{{ dialog_selected_item.PROCESS_STATE }}</div>
    </v-col>
    </v-row>

    <v-divider></v-divider>
    <v-row>
        <v-col cols="12" sm="5"  class="dialog_title_text">처리일시</v-col>
        <v-col class="dialog_info_text">
            {{ dialog_selected_item.DISPATCH_DT == null?'':dialog_selected_item.DISPATCH_DT }}
        </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row v-if="dropdown_selected == 'CANCEL'">
        <v-col  cols="5"  class="dialog_title_text">코멘트</v-col>    
    </v-row>
    <v-divider></v-divider>
    <v-row v-if="dropdown_selected == 'CANCEL' && dialog_selected_item.PROCESS_STATE == 'WAIT'">
        <v-col v-if="dialog_selected_item.PROCESS_STATE == 'WAIT'">
            <v-text-field 
                label="취소 환불사유 (완료시 작성 필요없음)"
                v-model="dialog_cancel_commment" 
                outlined
                dense
            ></v-text-field>
        </v-col>
    </v-row>
    <v-row  v-if="dialog_selected_item.PROCESS_STATE == 'CANCEL'">
        <v-col  cols="5"  class="dialog_title_text">취소사유</v-col>    
        <v-col class="dialog_title_text">
         {{ dialog_selected_item.COMMENT }}
        </v-col>
    </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="OnClick_ClosePopup"
          >
            취소
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="OnClick_EditProductCoin"
          >
            확인
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>    
    
</template>

<script>
import { mapActions } from 'vuex';
import config from '../../config/config';
const XLSX = require('xlsx');
const { s3_upload , FileUpload_Async ,  FileUpload_JSON} = require("../../util/fileutil");
export default {
    name: 'UserList',

    data: () => ({
        loadingData:false,

        items :[{title:'USER_ID',
        subtitle:'닉네임',
        action:'우편' }],
        headers: [
            { text: '은행', value: 'bank' },
            { text: '입금계좌', value: 'account' },
            { text: '입금액', value: 'cash' },
            { text: '사람이름', value: 'name' },
            { text: '전화번호', value: 'phone' },
            { text: '구매요청 시각', value: 'datetime' },
            { text: '주문번호', value: 'pid' },
            { text: '유저아이디', value: 'user_id' },
            { text: '선택', value: 'select' },
            { text: '상태', value: 'state' },
            { text: '관리', value: 'manage' },
        ],
        order_list:[],
        total_count:0,
        search_keyword:'',

        dialog_selected_item: {},
        dialog_popup:false,
        dialog_cancel_commment:'',
        enable_check_list: {},

        dropdown_items: ['DONE', 'CANCEL'],
        dropdown_selected: null,
        dropdown_open: false,
    }),

    created()
    {
        console.log("TEST");
        this.Load_OrderList();
    },

    methods:{
        ...mapActions([
            "CARRYGOLD_GET_CASH_ORDER_LIST",
            "CARRYGOLD_SEARCH_CASH_ORDER_LIST",
            "CARRYGOLD_EDIT_CASH_ORDER_STATE",
        ]),
        Load_OrderList()
        {
            this.CARRYGOLD_GET_CASH_ORDER_LIST({count:200}).then((body_data)=>{
                this.order_list = body_data.order_list;
                //enable_check_list
                this.enable_check_list = {};
                this.order_list.forEach(element => {
                    
                    if(!this.isAfterThisMonday(element.CREATE_DT) && element.PROCESS_STATE == 'WAIT'){ 
                        this.$set(this.enable_check_list, element.PID, true);
                    }
                    //this.$set(element, 'selected', false); // Add selected property to each item
                });
                console.log(JSON.stringify(this.order_list));
            });
        },
        OnClick_SearchUser()
        {
            this.CARRYGOLD_SEARCH_CASH_ORDER_LIST({user_id:this.search_keyword}).then((body_data)=>{
                this.order_list = body_data.order_list;
                console.log(JSON.stringify(this.order_list));
            });
        },
 
        async OnClick_EditProductCoin() {
            let pid = this.dialog_selected_item.PID;
            let process_state = this.dropdown_selected;
            let comment = this.dialog_cancel_commment;
            if(process_state == "CANCEL"){
                if(comment == ''){
                    alert("취소처리에는 사유 작성이 필요합니다.");
                    return;
                }
            }
            this.CARRYGOLD__EDIT_CASH_ORDER_STATE({pid , process_state , comment}).then((body_data)=>{
                this.Load_OrderList();
            });
            this.OnClick_ClosePopup();
        },
        OnClick_ShowPopup_EditCoin(item)
        {
        //dialog_selected_item
            this.dialog_selected_item = item;
            this.dialog_popup = true;
        },    
        OnClick_ClosePopup()
        { 
            this.dialog_popup = false;
        },       
        formatCoin(value) {
            if (typeof value !== 'number') return value;
            return value.toLocaleString();
        },
        toggleDropdown() {
            this.dropdown_open = !this.dropdown_open
        },
        selectItem(item) {
            this.dropdown_selected = item
            this.dropdown_open = false
        },
        handleClickOutside(event) {
            if (!this.$el.contains(event.target)) {
                this.dropdown_open = false
            }
        },
       convert_phone(phone) {
            if (!phone) { return ''; }
            
            // 숫자만 남기기
            phone = phone.replace(/\D/g, '');
            
            // 11자리 (예: 010-1234-5678)
            if (phone.length === 11) {
                return phone.substring(0, 3) + '-' + phone.substring(3, 7) + '-' + phone.substring(7);
            }
            
            // 10자리 (예: 02-1234-5678 또는 031-123-4567)
            if (phone.length === 10) {
                return phone.substring(0, 3) + '-' + phone.substring(3, 6) + '-' + phone.substring(6);
            }
            
            // 그 외는 원본 반환
            return phone;
        },
        calc_realcash(pid){
            if(pid== 170)
                return 10000;
            else if(pid== 171)
                return 20000;   
            else if(pid== 172)
                return 40000;   
            else if(pid== 12)
                return 100000;   
            else
                return 0;

        },
        isAfterThisMonday(dateStr) {
            if (!dateStr) return false;
            const inputDate = new Date(dateStr.replace(/-/g, '/'));
            const now = new Date();
            // Get this week's Monday 00:00:00
            const day = now.getDay();
            const diff = now.getDate() - day + (day === 0 ? -6 : 1); // Monday as start of week
            const monday = new Date(now.setDate(diff));
            monday.setHours(0, 0, 0, 0);
            return inputDate >= monday;
        },
        isEnableCheckBox(pid)
        {
            let isEnableState = Object.prototype.hasOwnProperty.call(this.enable_check_list, pid);
            return isEnableState;            
        },
        checkBoxEnable_all()
        {
            this.order_list.forEach(element => {
                if(this.isEnableCheckBox(element.PID)){
                    this.$set(element, 'selected', true);
                }
            });
        },
        update_checked_Done() {
            const selected_pids = this.order_list
                .filter((item) => item.selected)
                .map((item) => item.PID);

            if (selected_pids.length === 0) {
                alert("선택된 항목이 없습니다.");
                return;
            }

            if (!confirm("선택된 항목을 완료처리 하시겠습니까?")) {
                return;
            }

            const failed = [];
            //     this.CPU_EDIT_CASH_ORDER_STATE({pid , process_state , comment}).then((body_data)=>{
               // this.Load_OrderList();
            //});
            // reduce로 순차 실행 체인 구성
            selected_pids
                .reduce((p, pid) => {
                return p.then(() => {
                    return this.CARRYGOLD_EDIT_CASH_ORDER_STATE({
                    pid: pid,
                    process_state: "DONE",
                    comment: ""
                    }).catch((e) => {
                    failed.push({ pid: pid, reason: e });
                    });
                });
                }, Promise.resolve())
                .then(() => {
                if (failed.length > 0) {
                    const msg = failed.map((f) => `PID ${f.pid}: ${String(f.reason)}`).join("\n");
                    alert(`일부 항목 처리 실패:\n${msg}`);
                }
                })
                .finally(() => {
                this.Load_OrderList();
                });
            },
        download_checked_Excel() {
            const selected = this.order_list.filter(item => item.selected);
            if (selected.length === 0) {
                alert('선택된 항목이 없습니다.');
                return;
            }

            const BANKBOOK_LABEL = '포인트 채굴기';
            const today = new Date().toISOString().slice(0, 10);

            const rows = selected.map(item => ({
                '입금은행': item.BANK_NAME || '',
                '입금계좌번호': item.BANK_ACCOUNT || '',
                '입금액': this.calc_realcash(item.CASH_PID),
                '예상예금주': item.RECIPIENT_NM || '',
                '입금통장표시': BANKBOOK_LABEL,
                '출금통장표시': BANKBOOK_LABEL,
                '메모': today,
                'CMS코드': '',
                '받는분 휴대폰번호': this.convert_phone(item.PHONE) || ''
            }));

            const ws = XLSX.utils.json_to_sheet(rows);
            const range = XLSX.utils.decode_range(ws['!ref']);
            for (let r = range.s.r + 1; r <= range.e.r; r++) {
                const cell = ws[XLSX.utils.encode_cell({ r, c: 1 })];
                if (cell) { cell.t = 's'; cell.z = '@'; }
            }
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

            XLSX.writeFile(wb, `현금교환_${today.replace(/-/g, '')}.xlsx`);
        }
    },
    computed: {
        selectedCount() {
            return this.order_list.filter(item => item.selected).length;
        }
    },


    components:{
    },
    watch :{
    }
};
</script>

<style scoped>
.dialog_title_text {
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 6px;
    margin-top: 6px;
}

.dialog_info_text {
    font-weight: bold;
    font-size: 16px;
    margin-top: 7px;
}

.dropdown {
  position: relative;
  width: 200px;
}

.dropdown-button {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  background-color: white;
  text-align: left;
  cursor: pointer;
}

.dropdown-menu {
    position: absolute;
  top: 100%;
  left: 0;
}

.dropdown-menu li {
  padding: 10px;
  cursor: pointer;
}

.dropdown-menu li:hover {
  background-color: #f0f0f0;
}

</style>
